import { render, staticRenderFns } from "./ot-checkbox-wrapper.vue?vue&type=template&id=1401eff5&scoped=true&"
import script from "./ot-checkbox-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-checkbox-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-checkbox-wrapper.vue?vue&type=style&index=0&id=1401eff5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1401eff5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
